import { mapGetters } from 'vuex'

const paymentOptions = {
  ff_payout_stripe_issuing_virtual: 'STRIPE_CARD_ISSUING_DIGITAL',
  ff_payout_stripe_issuing_physical: 'STRIPE_CARD_ISSUING_PHYSICAL',
  ff_payout_stripe_connect: 'STRIPE_DIRECT_DEPOSIT',
}

export default {
  computed: {
    ...mapGetters('dashboard', [
      'connectAccount',
      'issuingPhysicalAccount',
      'issuingVirtualAccount',
    ]),
  },
  methods: {
    async getAvailablePaymentOptions() {
      const paymentFlags = await this.getPaymentFlags()
      return Object.keys(paymentOptions)
        .filter((flag) => paymentFlags[flag])
        .map((flag) => paymentOptions[flag])
    },
    async getPaymentAccounts() {
      const availablePaymentOptions = await this.getAvailablePaymentOptions()
      const hasConnectAccount =
        this.connectAccount &&
        availablePaymentOptions.includes('STRIPE_DIRECT_DEPOSIT')
      const hasIssuingPhysicalAccount =
        this.issuingPhysicalAccount &&
        availablePaymentOptions.includes('STRIPE_CARD_ISSUING_PHYSICAL')
      const hasIssuingVirtualAccount =
        this.issuingVirtualAccount &&
        availablePaymentOptions.includes('STRIPE_CARD_ISSUING_DIGITAL')

      return [
        ...(hasConnectAccount ? [this.connectAccount] : []),
        ...(hasIssuingPhysicalAccount ? [this.issuingPhysicalAccount] : []),
        ...(hasIssuingVirtualAccount ? [this.issuingVirtualAccount] : []),
      ]
    },
    async isPaymentMethodPresent(methodId) {
      const availablePaymentOptions = await this.getAvailablePaymentOptions()
      if (availablePaymentOptions.includes(methodId)) {
        switch (methodId) {
          case 'STRIPE_DIRECT_DEPOSIT':
            return Boolean(this.connectAccount)
          case 'STRIPE_CARD_ISSUING_PHYSICAL':
            return Boolean(this.issuingPhysicalAccount)
          case 'STRIPE_CARD_ISSUING_DIGITAL':
            return Boolean(this.issuingVirtualAccount)
        }
      }
      return false
    },
    async getPaymentFlags() {
      const flags = Object.keys(paymentOptions).map((flag) => ({ name: flag }))
      return await this.$featureFlag.isEnabled(flags)
    },
  },
}
